"use client";

import { useState } from "react";
import {AuthProvider} from './provider'
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { RoutesPages } from './Routes'
//import { ErrorBoundary } from "react-error-boundary";
//import ErrorPage from "./components/Errors/ErrorPage";
import { ColorModeContext, useMode } from "./theme";
import { I18nProvider } from "./language";
import { TourProvider } from './components/Tour/WalkthroughTour';
import WalkthroughTour from './components/Tour/WalkthroughTour';
import { MetaPixelProvider } from './components/MetaPixel/MetaPixel';


function App() {

  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <I18nProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />

              <TourProvider>
                <AuthProvider>
                  <MetaPixelProvider>
                    <WalkthroughTour />
                    <RoutesPages />
                  </MetaPixelProvider>
                </AuthProvider>
              </TourProvider>

        </ThemeProvider>
        </I18nProvider>
    </ColorModeContext.Provider>

  );  
}

export default App;
